class FormObserver {

    constructor(params) {
        // TODO Als parameter buttons mee geven

        this.form = $('.form .content-body');

        if (typeof params != 'undefined') {
            this.params = params;

            if (typeof this.params.form != 'undefined') {
                this.form = this.params.form
            }
        }

        this.formExcists = false;
        if (this.form.length || this.form != null) {
            this.formExcists = true;
        }

        this.ignore = true;
        this.changedElements = []

        this.events();

    }

    events() {

        let self = this;


        $(this.form).on('focus', 'input, textarea, select', function (e) {

            if (typeof e.originalEvent != 'undefined' &&
                typeof $(this).data('@original_value') == 'undefined') {

                $(this).data('@original_value', self.getActualValue($(this)));
            }
        });

        $(this.form).on('change', 'input, textarea, select', function (e) {

            if (typeof e.originalEvent != 'undefined') {
                if ($(this).data('@original_value') != self.getActualValue($(this))) {

                    self.changedElements.push($(this).prop('name'));
                } else {

                    let index = $.inArray($(this).prop('name'), self.changedElements);

                    console.log(index)
                    if (index !== -1) {
                        delete self.changedElements[index];
                    }
                }
            }
        });

        $('.form').on('click', '.content-header input[type="submit"], .content-header a[type="button"]', function (e) {

            if (self.formExcists) {
                self.ignore = false;
            }
        });


        $(window).on("beforeunload", function (e) {

            if (self.formExcists &&
                self.ignore &&
                self.changedElements.filter(o => !!o).length) {

                return true;
            }
        });


    }

    getActualValue(item) {
        if (item.prop('type') == 'checkbox') {
            let value = item.is(":checked")
                ? 1
                : 0;

            return value
        } else {
            return item.val();
        }
    }
}